import { skipToken, useMutation, useQuery } from "@tanstack/react-query"
import { winbackKeys } from "./queryKeys"
import { acceptWinbackOffer, getWinback, getWinbackOffers } from "./winbacks"
import type { IUserIdParams } from "@commonTypes/user"
import { accountKeys } from "@apis/accounts/queryKeys"

export const useGetWinbackQuery = (
  account_id: string,
  isEnabled: boolean = true,
) => {
  return useQuery({
    queryKey: winbackKeys.detail(account_id),
    queryFn: isEnabled ? () => getWinback(account_id) : skipToken,
  })
}

export const useGetWinbackOffersQuery = (
  account_id: string,
  params: IUserIdParams,
  isEnabled: boolean = true,
) => {
  return useQuery({
    queryKey: accountKeys.winbackOffersForAccount(account_id, params),
    queryFn: isEnabled ? () => getWinbackOffers(account_id, params) : skipToken,
    select: (response) => ({
      ...response.data,
      requestId: response.headers["x-request-id"]?.split("-")[0] ?? "",
    }),
  })
}

export const useAcceptWinbackOfferMutation = () => {
  return useMutation({
    mutationFn: acceptWinbackOffer,
  })
}
